<template>
  <print ref="print"></print>
</template>
<script>
import print from "@/components/common/customprint/index";
export default {
  components: { print },
  data() {
    return {
      api: require("@/api/pu/puOrder").default,
      data: {}
    }
  },
  mounted() {
    var josn_str = sessionStorage.getItem("emptordetails_print");
    if (josn_str) this.data = JSON.parse(josn_str);
    // console.log('params', this.data);
    this.api.detailList(this.data.Params).then(res => {
      if (res.Code == 0) {
        var data = {
          Title: "采购订单明细表", TableNames: this.data.TableNames, Params: this.data.Params,
          ParamsData: this.data.ParamsData, List: res.Data
        };
        this.$refs.print.setData(data);
      }
    })
  },
}
</script>